var map = {
	"./douban_black.png": "yaK1",
	"./news_header.jpg": "3lKg",
	"./qq_black.png": "ZZ0E",
	"./service_notice.jpg": "u2Tx",
	"./weixin_black.png": "Va6S",
	"./xinlang_black.png": "dA82"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "O87v";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yearContent ^\.\/.*$
// module id = O87v
// module chunks = 2